// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media (-ms-high-contrast:active),(-ms-high-contrast:none){.documentMenuClass.v-menu__content{min-width:200px!important}}", ""]);
// Exports
module.exports = exports;
